webpackJsonp([1],{

/***/ "0WT+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3/x3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);



var transitionMixin = {

    data: function data() {
        return {
            // mobile: window.innerWidth <= 768
            // showVideo: false
        };
    },

    created: function created() {
        var self = this;
    },

    computed: {
        mobile: function mobile() {
            return this.$store.getters['app/getWidth'] <= 768;
        }
    },

    methods: {

        afterEnter: function afterEnter(el, done) {},

        enter: function enter(el, done) {

            if (this.mobile) {
                done();
                return;
            }

            var tl = new TimelineMax({
                onComplete: done
            });

            tl.set(el, {
                // y: 20,
                opacity: 0
                // transformOrigin: '50% 50%'
            });

            tl.to(el, 1, {
                // y: 0,
                delay: 0.1,
                opacity: 1
            });
        },
        leave: function leave(el, done) {

            if (this.mobile) {
                done();
                return;
            }

            __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).addClass('transitioning-out');

            TweenMax.to(el, 1, {
                opacity: 0,
                delay: 0.1,
                y: -20,
                // height: 0,
                onComplete: done
            });
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (transitionMixin);

/***/ }),

/***/ "6ko7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AzBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_event_bus__ = __webpack_require__("GkWU");

//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import imagesLoaded from 'vue-images-loaded';
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    name: 'parallax',
    directives: {
        // imagesLoaded
    },
    methods: {
        layout: function layout() {
            this.initParallax();
        }
    },

    data: function data() {
        return {
            height: 0,
            bounds: {},
            topBound: 0
        };
    },

    mounted: function mounted() {
        this.initParallax();
    },


    props: ['speedFactor', 'wrapped', 'global'],

    computed: {

        classObject: function classObject() {
            return {
                'wrapped': this.wrapped
            };
        },

        scrollTop: function scrollTop() {
            return this.$store.getters['app/getState']('scrollTop');
        },
        elTransform: function elTransform() {

            var start = this.topBound - window.innerHeight;

            var end = start + window.innerHeight + this.height;
            end += this.wrapped ? 0 : this.move / 2;

            var percentage = this.scrollProgress(start, end, this.scrollTop);
            var currentMove = this.move * percentage;

            return 'translate3d(' + 0 + 'px,' + currentMove + 'px, ' + 0 + 'px)';
        },
        move: function move() {
            return this.global ? window.innerHeight * this.speedFactor : this.height * this.speedFactor;
        },
        elHeight: function elHeight() {
            if (!this.wrapped) {
                return;
            }

            var newh = this.height + Math.abs(this.move);

            return newh;
        },
        elTop: function elTop() {
            var m = -this.move;

            return this.wrapped && m > 0 ? 0 : this.wrapped ? m : m / 2;
        }
    }

}, 'methods', {
    initParallax: function initParallax() {
        var _this = this;

        var self = this;

        __WEBPACK_IMPORTED_MODULE_1__config_event_bus__["a" /* default */].$on('scrolling', function (top) {
            _this.scrollTop = top;
        });

        // setTimeout(function(){
        requestAnimationFrame(function () {
            self.resizeHandler();
            self.setupListeners();
        });
        // }, 200);
    },


    // returning the scroll progress from 0 to 1 in between start/end pixels
    scrollProgress: function scrollProgress(start, end, scrollTop) {
        var scrollTop = scrollTop || this.scrollTop,
            factor = (end - start) / 100,
            scrollStart = (scrollTop - start) / factor,
            percentage = scrollTop >= start && scrollTop <= end ? scrollStart / 100 : scrollTop > start ? 1 : 0;

        return percentage;
    },
    setupListeners: function setupListeners() {
        window.addEventListener('resize', this.resizeHandler, false);
    },
    resizeHandler: function resizeHandler() {

        if (!this.$el) {
            return;
        }

        this.height = this.$el.offsetHeight;
        this.bounds = this.$el.getBoundingClientRect();
        this.topBound = this.bounds.top + this.scrollTop;
    }
}));

/***/ }),

/***/ "FmZd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-size",attrs:{"id":"app"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/logo.png"}}),_vm._v(" "),_c('transition',{attrs:{"css":false},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"bold"},[_c('a',{staticClass:"underline-link",class:_vm.classObject,attrs:{"href":"https://www.google.rs/maps/place/Carrer+de+Muntaner,+267,+08021+Barcelona,+Spain/@41.3956259,2.146356,18.05z/data=!4m13!1m7!3m6!1s0x12a4a29dcd475137:0x41e01a4da147cc85!2sCarrer+de+Muntaner,+267,+08021+Barcelona,+Spain!3b1!8m2!3d41.3955925!4d2.1474064!3m4!1s0x12a4a29dcd475137:0x41e01a4da147cc85!8m2!3d41.3955925!4d2.1474064?hl=en","target":"_blank"}},[_vm._v("Klimentská 24, Praha 1, 110 00 Czech Republic")])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"bold t-center"},[_c('a',{staticClass:"underline-link",class:_vm.classObject,attrs:{"href":"mailto:contact@jtw.cz"}},[_vm._v("contact@jtw.cz")])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"bold t-right"},[_c('a',{staticClass:"underline-link",class:_vm.classObject,attrs:{"href":"tel:+420777676708"}},[_vm._v("(420) 777 676 708")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GkWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ "HXef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("dPB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78584436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("WJJ6");
function injectStyle (ssrContext) {
  __webpack_require__("RHTc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78584436"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78584436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a0acd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("FmZd");
function injectStyle (ssrContext) {
  __webpack_require__("hYA8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a0acd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_router__ = __webpack_require__("OFFm");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_6__config_router__["a" /* routes */],
    mode: 'history'
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(store, router);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    router: router,
    store: store,
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]);
    }
}).$mount('#app');

/***/ }),

/***/ "OFFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
/* unused harmony export VueRouterObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__("HXef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Video__ = __webpack_require__("xzpI");



var routes = [{
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Home__["a" /* default */]
}, {
  path: '/video',
  name: 'Video',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Video__["a" /* default */]
}, { path: '*' }];

var VueRouterObject = {
  routes: routes,
  mode: 'history',
  saveScrollPosition: true
};

/* unused harmony default export */ var _unused_webpack_default_export = (function (VueRouter) {
  return new VueRouter(VueRouterObject);
});

/***/ }),

/***/ "RHTc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RL/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var mutations = {
   SET_SCROLLTOP: function SET_SCROLLTOP(state, _ref) {
      var scrollTop = _ref.scrollTop;

      state.scrollTop = scrollTop;
   },
   SET_WIDTH: function SET_WIDTH(state, _ref2) {
      var width = _ref2.width;

      state.width = width;
   },
   SET_MOBILE: function SET_MOBILE(state, _ref3) {
      var isMobile = _ref3.isMobile;

      state.isMobile = isMobile;
   },
   SET_STATE: function SET_STATE(state, _ref4) {
      var prop = _ref4.prop,
          value = _ref4.value;

      state[prop] = value;
   }
};

var actions = {
   SET_SCROLLTOP: function SET_SCROLLTOP(_ref5, top) {
      var commit = _ref5.commit;

      if (top) {
         commit('SET_SCROLLTOP', { scrollTop: top });
      }
   },
   SET_WIDTH: function SET_WIDTH(_ref6, width) {
      var commit = _ref6.commit;

      if (width) {
         commit('SET_WIDTH', { width: width });
      }
   },
   SET_MOBILE: function SET_MOBILE(_ref7, isMobile) {
      var commit = _ref7.commit;

      if (isMobile) {
         commit('SET_MOBILE', { isMobile: isMobile });
      }
   },
   SET_STATE: function SET_STATE(_ref8, obj) {
      var commit = _ref8.commit;

      var value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(obj)[0];
      var prop = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
      commit('SET_STATE', { prop: prop, value: value });
   }
};

var getters = {
   getScrollTop: function getScrollTop(state) {
      return state.scrollTop;
   },
   getWidth: function getWidth(state) {
      return state.width;
   },
   getMobile: function getMobile(state) {
      return state.isMobile;
   },
   getState: function getState(state) {
      return function (prop) {
         return state[prop];
      };
   }
};

var state = {
   scrollTop: 0,
   width: window.innerWidth
};

/* harmony default export */ __webpack_exports__["a"] = ({
   namespaced: true,
   actions: actions,
   getters: getters,
   state: state,
   mutations: mutations
});

/***/ }),

/***/ "SfUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video full-size page",class:_vm.classObject},[_c('video',{staticClass:"full-size",attrs:{"autoplay":"","loop":"","defaultMuted":"","src":"/static/newfilm.mp4"},on:{"click":_vm.play}}),_vm._v(" "),_c('router-link',{staticClass:"close-link bold",attrs:{"to":{ name: 'Home'}}},[_c('img',{staticClass:"arrow",attrs:{"src":"/static/arrow.png"}}),_vm._v(" Back")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TDqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_vue__ = __webpack_require__("AzBG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac26285_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_vue__ = __webpack_require__("wBx2");
function injectStyle (ssrContext) {
  __webpack_require__("0WT+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ac26285"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parallax_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ac26285_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_parallax_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WJJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-size home page container"},[_c('div',{staticClass:"row"},[_c('parallax',{class:"box-wrapper col6 col-1",attrs:{"speedFactor":0.1}},[_c('div',{staticClass:"box wide"},[_c('parallax',{class:"absolute full-size",attrs:{"speedFactor":0.3,"wrapped":"true"}},[_c('div',{staticClass:"cover full-size",style:({ backgroundImage: ("url('" + _vm.image + "')") })})])],1),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Prague Castle")])]),_vm._v(" "),_c('parallax',{class:"box-wrapper col6 col-2",attrs:{"speedFactor":-0.2}},[_c('div',{staticClass:"box wide"},[_c('parallax',{class:"absolute full-size",attrs:{"speedFactor":0.3,"wrapped":"true"}},[_c('div',{staticClass:"cover full-size",style:({ backgroundImage: ("url('" + _vm.image2 + "')") })})])],1),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Austrian parliament")])]),_vm._v(" "),_c('parallax',{class:"box-wrapper col4 col-3",attrs:{"speedFactor":-0.5}},[_c('div',{staticClass:"box"},[_c('parallax',{class:"absolute full-size",attrs:{"speedFactor":0.3,"wrapped":"true"}},[_c('div',{staticClass:"cover full-size",style:({ backgroundImage: ("url('" + _vm.image3 + "')") })})])],1),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Berlin Street")])]),_vm._v(" "),_c('parallax',{class:"box-wrapper col6 col-4",attrs:{"speedFactor":-0.4}},[_c('div',{staticClass:"box wide"},[_c('parallax',{class:"absolute full-size",attrs:{"speedFactor":0.3,"wrapped":"true"}},[_c('div',{staticClass:"cover full-size",style:({ backgroundImage: ("url('" + _vm.image4 + "')") })})])],1),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Flat in Prague Sumavska XIII")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_app__ = __webpack_require__("RL/B");
// import pages from './modules/pages';


/* harmony default export */ __webpack_exports__["a"] = ({
    modules: {
        // pages,
        app: __WEBPACK_IMPORTED_MODULE_0__modules_app__["a" /* default */]
    },
    strict: true
});

/***/ }),

/***/ "dPB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_event_bus__ = __webpack_require__("GkWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_basePage__ = __webpack_require__("zLrG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transition__ = __webpack_require__("3/x3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parallax__ = __webpack_require__("TDqM");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'home',
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_basePage__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transition__["a" /* default */]],

    components: {
        Parallax: __WEBPACK_IMPORTED_MODULE_3__components_parallax__["a" /* default */]
    },

    computed: {
        isMobile: function isMobile() {
            return this.$store.getters['app/getMobile'];
        },
        image: function image() {
            return "/static/prague.jpg";
        },
        image2: function image2() {
            return "/static/parlament.jpg";
        },
        image3: function image3() {
            return "/static/berlin.jpg";
        },
        image4: function image4() {
            return "/static/suma.jpg";
        }
    },

    methods: {},

    created: function created() {},
    updated: function updated() {},
    mounted: function mounted() {
        var self = this;
    },
    beforeDestroy: function beforeDestroy() {}
});

/***/ }),

/***/ "hYA8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wBx2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"holder",staticClass:"parallax-wrapper",class:_vm.classObject},[_c('div',{ref:"parallax",staticClass:"parallax",class:{'not-wrapped' : !_vm.wrapped},style:({ transform: _vm.elTransform, top: _vm.elTop + 'px', height: _vm.elHeight + 'px' })},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xGCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_transition__ = __webpack_require__("3/x3");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'Video',

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_transition__["a" /* default */]],

    data: function data() {
        return {
            msg: 'Tickets'
        };
    },


    components: {},

    methods: {
        play: function play(e) {
            var video = e.currentTarget;
            video.addEventListener('click', function () {
                video.play();
            }, false);
        }
    },

    computed: {
        // classObject: () => ({
        //   'isMobile': this.$store.getters['app/getMobile']
        // })

        classObject: function classObject() {
            return {
                'isMobile': this.$store.getters['app/getMobile']
            };
        }
    }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_transition__ = __webpack_require__("3/x3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: {},

    events: {},

    mounted: function mounted() {},

    computed: {
        isHome: function isHome() {
            var pageName = this.$store.state.route.name;
            return pageName === 'Home';
        },
        classObject: function classObject() {
            return {
                'wht-link': !this.isHome,
                'dark-link': !this.isHome
            };
        }
    },

    created: function created() {
        var self = this;
        window.addEventListener('resize', function () {
            self.onResize();
        });

        var mobile = this.detectMobile();
        this.$store.dispatch('app/SET_MOBILE', mobile);
    },


    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_transition__["a" /* default */]],

    methods: {
        onResize: function onResize() {
            this.$store.dispatch('app/SET_STATE', {
                pageHeight: window.innerHeight
            });

            this.$store.dispatch('app/SET_STATE', {
                pageWidth: window.innerWidth
            });
        },
        detectMobile: function detectMobile() {
            var a = navigator.userAgent || navigator.vendor || window.opera;

            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                return true;
            }
        }
    }
});

/***/ }),

/***/ "xzpI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__ = __webpack_require__("xGCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb0bdd36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__ = __webpack_require__("SfUq");
function injectStyle (ssrContext) {
  __webpack_require__("6ko7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb0bdd36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb0bdd36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zLrG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__("+Uzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_event_bus__ = __webpack_require__("GkWU");



// import BaseComponent from '@/components/Content'


var basePage = {
   props: ['model'],

   components: {
      // BaseComponent
   },

   computed: {
      pageComponents: function pageComponents() {
         var attributes = this.model && this.model.attributes;

         if (!attributes) {
            return null;
         }

         return attributes.components.value;
      }
   },
   created: function created() {},

   mounted: function mounted() {
      console.log("init");
      this.initSmooth();
   },


   methods: {
      onScroll: function onScroll(e) {
         var self = this;

         console.log("EE", e.target.scrollTop);

         self.$store.dispatch('app/SET_STATE', { scrollTop: e.target.scrollTop });
         return;

         if (!ticking) {

            window.requestAnimationFrame(function () {
               self.$store.dispatch('app/SET_STATE', { scrollTop: e.target.scrollTop });
               ticking = false;
            });
            ticking = true;
         }
      },
      initSmooth: function initSmooth() {
         var self = this;

         this.$el.removeEventListener('scroll', self.onScroll);
         this.$el.addEventListener('scroll', self.onScroll);
         return;
      },
      getScrollTop: function getScrollTop() {
         if (typeof pageYOffset != 'undefined') {
            //most browsers
            return pageYOffset;
         } else {
            var B = document.body; //IE 'quirks'
            var D = document.documentElement; //IE with doctype
            D = D.clientHeight ? D : B;
            return D.scrollTop;
         }
      },
      scrollHandler: function scrollHandler(e) {
         var top = e.srcElement.scrollTop;

         requestAnimationFrame(function () {
            __WEBPACK_IMPORTED_MODULE_2__config_event_bus__["a" /* default */].$emit('scrolling', top);
         });
      },
      mousemoveHandler: function mousemoveHandler(e) {
         // var top = e.srcElement.scrollTop;

         requestAnimationFrame(function () {
            __WEBPACK_IMPORTED_MODULE_2__config_event_bus__["a" /* default */].$emit('mousemove', pos);
         });
      }
   }
};

/* harmony default export */ __webpack_exports__["a"] = (basePage);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d788f7e432206afcd567.js